var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('AdvancedTableWidget3',{attrs:{"whitelists":_vm.whitelists}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }